import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { fileGroupOptions, statusOptions, yesNoOptions } from '../../../utils/mics';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

const FileUploadFilterForm = (props) => {

    const dispatch = useDispatch();

    const filters = useSelector((state) => state.fileUpload.filters);

    const { handleSearch, handleReset, onFormValuesChange } = props;

    const formik = useFormik({
        initialValues: {
            fileId: filters?.fileId || '',
            storeid: filters?.storeid || '',
            uploadGroup: filters?.uploadGroup || null,
            date_from: filters?.date_from || '',
            date_till: filters?.date_till || '',
            processed: filters?.processed || null,
            error: filters?.error || null,
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };
            dispatch(appActions.FILEUPLOAD_SET_FILTERS_REQUEST(values));
            handleSearch(data);
        },
    });

    const handleClear = () => {
        dispatch(appActions.FILEUPLOAD_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const updatedValues = { ...formik.values, [e.target.name]: e.target.value };
             const data = {
                ...updatedValues,
                date_from: updatedValues.date_from ? moment(updatedValues.date_from).format('YYYY-MM-DD') : '',
                date_till: updatedValues.date_till ? moment(updatedValues.date_till).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }
    }

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes

    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">
                <div className="field col-12 md:col-3">
                        <label htmlFor="fileId">File Id</label>
                        <InputText id="fileId" name="fileId" type="text" value={formik.values.fileId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="storeid">Store Id</label>
                        <InputText id="storeid" name="storeid" type="text" value={formik.values.storeid} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="uploadGroup">Upload Group</label>
                        <Dropdown showClear  value={formik.values.uploadGroup} onChange={formik.handleChange} options={fileGroupOptions}  id="uploadGroup" name="uploadGroup" optionLabel="name" optionValue='name' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="tierrortle">Error</label>
                            <Dropdown showClear  value={formik.values.error} onChange={handleChange} options={yesNoOptions}  id="error" name="error" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="processed">Processed</label>
                            <Dropdown showClear value={formik.values.processed} onChange={handleChange} options={yesNoOptions} id="processed" name="processed" optionLabel="name" optionValue='code' />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="status">Status</label>
                        <Dropdown showClear value={formik.values.status} onChange={handleChange} options={statusOptions} id="status" name="status" optionLabel="name" optionValue='name' placeholder="Select status"  />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy"  showIcon minDate={formik.values.date_from}/>
                    </div>
                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" data-pr-tooltip="Search" severity="success" outlined className="p-button-success mr-2 tp" />
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined onClick={handleClear} />
                </div>
            </>
        );
    };
    
    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default FileUploadFilterForm;
